import React from 'react';
import { Box, Typography } from '@mui/material';

interface StepNavigatorProps {
  currentStep?: string;
  steps?: string[];
}

const DEFAULT_STEPS = ['Purpose', 'Learning objectives', 'Document upload', 'Review', 'People'];

const StepNavigator: React.FC<StepNavigatorProps> = ({ currentStep, steps = DEFAULT_STEPS }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}
    >
      {steps.map((step) => {
        const isActive = currentStep?.toLowerCase() === step.toLowerCase();
        return (
          <Box
            key={step}
            sx={{
              width: 120,
              display: 'inline-flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Box
              sx={{
                alignSelf: 'stretch',
                height: 5,
                borderRadius: 50,
                background: isActive ? '#F15A26' : 'transparent',
                border: isActive ? 'none' : '1px solid #565656'
              }}
            />
            <Typography
              alignSelf="stretch"
              textAlign="center"
              sx={{
                color: isActive ? '#F15A26' : '#565656',
                fontSize: 10,
                fontFamily: 'Inter, sans-serif',
                fontWeight: isActive ? 700 : 400,
                lineHeight: '10px'
              }}
            >
              {step}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default StepNavigator;
